var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"flatpickr"},[_vm._t("default",null,{"isMobile":_vm.isMobile,"picker":_vm.picker})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }